module.exports = {"150623100":"敖勒召其镇","150623101":"上海庙镇","150623102":"城川镇","150623103":"昂素镇","150623400":"上海庙经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150623.json
// module id = 440
// module chunks = 0